$('document').ready(function(){
  var template = getTemplate();
  var productHandle = getProductHandle();
  preFillEmail(getURLParam('email'));

  initHubspotEmailFooter();
  initHubspotEmailSlideout(); 
  initGtranslate();

  if(template == 'product'){
    if(productHandle == 'mtc-2-starter-kit' || productHandle == 'mtc-device'){
      initMTC();
    }
  }

  if(template == 'index'){
    initTestimonialSlider();
    initPartnerSlider();
  }

  if(template == 'cart'){
    initCartCompatibilityBanner();
  }

  if($("#annual-service-plan-owm").length != 0) {
    initSubDurationPage();
  }

});


function initHubspotEmailSlideout() {
  
//   let thankyou_url = 'https://sirenmarine.com/pages/email-signup-confirmation'; 
  
  var checkExist = setInterval(function() {
     if ($('.leadinModal-content').length) {       
        $('.leadin-button').click(function () {
          $('.leadin-submit').click(function () {
		    fbq('track', 'Subscribe');
            gtag_report_conversion(); 
          });
        });
       
        clearInterval(checkExist);
     }
  }, 5000);
  
}

function gtag_report_conversion(url) {
  console.log("reporting email signup: ", url); 
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-1067269626/uubzCL7E8tIBEPr79PwD',
      'event_callback': callback
  });
  return false;
}


function initGtranslate() {


// look for gtranslate state in incoming links
let incoming_url = new URL(window.location.href);
let incoming_url_params = new URLSearchParams(incoming_url.search);

if ( incoming_url_params.get("googtrans") ) {
      // incoming_url_params.delete("googtrans");
      incoming_url.searchParams.delete("googtrans");
      window.history.replaceState(null, null, incoming_url.href);
      $('.gtranslate-header').find('select').val('en|'+incoming_url_params.get("googtrans"));
      // doGTranslate(document.querySelector('.gtranslate-header').children[0]);
  		setTimeout(function(){ doGTranslate(document.querySelector('.gtranslate-header').children[0]); }, 3000);
}


// send gtranslate state in outgoing links
$('.gt_link').each(function(index, value) {

  if ( $(this)[0].href.includes('zendesk') | $(this)[0].href.includes('web.sirenmarine.com/business') | $(this)[0].href.includes('blog.sirenmarine') ) {
      $(this).click(function( event ) {

          event.preventDefault();
          let gt_cookies = document.cookie.split(';');
          let gt_query_param = '';
          let language_found = false;

          for (var gt_cookie of gt_cookies) {
            if ( gt_cookie.includes('googtrans') ) {
              gt_query_param = gt_cookie.replace('googtrans=/en/','');
              gt_query_param = gt_query_param.replace(/\s+/g, '');
              console.log("gt_query_param=", gt_query_param);
              language_found = true;
            }
          }

          if ( !language_found ) {
            gt_query_param = 'en';
          }

          if ( gt_query_param != '' ) {
              let outgoing_url = new URL( $(this)[0].href );
              // let url_params = new URLSearchParams(incoming_url.search);
              outgoing_url.searchParams.append('googtrans', gt_query_param);
              window.location.href = outgoing_url.href;
              // console.log(outgoing_url.href);
          } else {
              window.location.href = $(this)[0].href;
              // console.log($(this)[0].href);
          }

      });
  }

});

// Supported Languages
// Engligh - en|en - US
// German - en|de - DE
// French - en|fr - FR
// Spanish - en|es - ES
// Portuguese - en|pt - PT
// Italian - en|it - IT
// Japanese - en|ja - JP
// Russian - en|ru
// Arabic - en|ar -
// Norwegian - en|no - NO
// Danish - en|da - DK
// Finnish - en|fi - FI
// Greek - en|el - GR
// Swedish - en|sv - SE


  let sm_cookies = document.cookie.split(';');
  let cookie_set = false;

  for (var sm_cookie of sm_cookies) {
    if ( sm_cookie.includes('googtrans') ) {
      cookie_set = true;

      if ( sm_cookie.includes('/en/ar') ) {
        $('.gtranslate-header').find('select').val('en|ar');
      } else if ( sm_cookie.includes('/en/da') ) {
        $('.gtranslate-header').find('select').val('en|da');
      } else if ( sm_cookie.includes('/en/fi') ) {
        $('.gtranslate-header').find('select').val('en|fi');
      } else if ( sm_cookie.includes('/en/fr') ) {
        $('.gtranslate-header').find('select').val('en|fr');
      } else if ( sm_cookie.includes('/en/de') ) {
        $('.gtranslate-header').find('select').val('en|de');
      } else if ( sm_cookie.includes('/en/el') ) {
        $('.gtranslate-header').find('select').val('en|el');
      } else if ( sm_cookie.includes('/en/it') ) {
        $('.gtranslate-header').find('select').val('en|it');
      } else if ( sm_cookie.includes('/en/no') ) {
        $('.gtranslate-header').find('select').val('en|no');
      } else if ( sm_cookie.includes('/en/pt') ) {
        $('.gtranslate-header').find('select').val('en|pt');
      } else if ( sm_cookie.includes('/en/ru') ) {
        $('.gtranslate-header').find('select').val('en|ru');
      } else if ( sm_cookie.includes('/en/es') ) {
        $('.gtranslate-header').find('select').val('en|es');
      } else if ( sm_cookie.includes('/en/sv') ) {
        $('.gtranslate-header').find('select').val('en|sv');
      }

    }
  }

  if ( localStorage.getItem('gtranslate_english') ) {
    cookie_set = true;
  }

  if ( !cookie_set ) {
    console.log("cookie not set");

    $.get("https://ipinfo.io", function(response) {

        switch (true) {

          case ( response.country == 'DE' ):
              $('.gtranslate-header').find('select').val('en|de');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'FR' ):
              $('.gtranslate-header').find('select').val('en|fr');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'ES' ):
              $('.gtranslate-header').find('select').val('en|es');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'PT' ):
              $('.gtranslate-header').find('select').val('en|pt');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'IT' ):
              $('.gtranslate-header').find('select').val('en|it');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'JP' ):
              $('.gtranslate-header').find('select').val('en|ja');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'NO' ):
              $('.gtranslate-header').find('select').val('en|no');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'DK' ):
              $('.gtranslate-header').find('select').val('en|da');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'FI' ):
              $('.gtranslate-header').find('select').val('en|fi');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'GR' ):
              $('.gtranslate-header').find('select').val('en|el');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          case ( response.country == 'SE' ):
              $('.gtranslate-header').find('select').val('en|sv');
              doGTranslate(document.querySelector('.gtranslate-header').children[0]);
              break;

          default:
              console.log("No translate action needed...");
        }


    }, "jsonp");

  }

  $('.gtranslate-header').find('select').on('change', function() {
      // console.log("language changed.....", $('.gtranslate-header').find('select').val() );
      if ( $('.gtranslate-header').find('select').val() == 'en|en' ) {
        localStorage.setItem('gtranslate_english', 'true');
      } else {
        if ( localStorage.getItem('gtranslate_english') ) {
          localStorage.removeItem('gtranslate_english');
        }
      }
  });

}


function initHubspotEmailFooter() {
  setTimeout(function(){
    document.getElementsByName('email')[0].placeholder='Enter your email';
  }, 3000);
}


function initCartCompatibilityBanner() {
  $('.compatibility-banner__close').on('click', function() {
    $('.compatibility-banner__warning').slideToggle(250);
  });
}

function initSubDurationPage() {

  $('input').on('click', function() {
      $('input').not(this).prop('checked', false);
      $('input').removeClass("checked");
      $(this).addClass("checked");
  });

}

function initPartnerSlider() {

  var sliderDesktop;

  if ($(window).width() > 750) {

    $('.partner-slider').slick({
      infinite: true,
      dots: true,
      slidesToShow: 6,
      slidesToScroll: 3,
      arrows: false,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 5000
    });

    sliderDesktop = true;

  } else {

    $('.partner-slider').slick({
      infinite: true,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 2,
      arrows: false,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 5000
    });

    sliderDesktop = false;

  }

  $(window).on('resize', function() {
      if ($(window).width() > 750) {
        if ( sliderDesktop == false ) {

          $('.partner-slider').slick('unslick');
          $('.partner-slider').slick({
            infinite: true,
            dots: true,
            slidesToShow: 6,
            arrows: false,
            slidesToScroll: 3,
            speed: 300,
            autoplay: true,
            autoplaySpeed: 5000
          });
          sliderDesktop = true;

        }
      }

      if ($(window).width() <= 750) {
        if ( sliderDesktop == true ) {

          $('.partner-slider').slick('unslick');
          $('.partner-slider').slick({
            infinite: true,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 2,
            arrows: false,
            speed: 300,
            autoplay: true,
            autoplaySpeed: 5000
          });
          sliderDesktop = false;

        }
      }
  });

}



function initTestimonialSlider() {

  $('.customer-reviews').slick({
    infinite: true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 2,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000
  });

  $('.customer-reviews-mobile').slick({
    infinite: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000
  });

}

function getURLParam(param){
  var pageURL = window.location.search.substring(1);
  var URLVariables = pageURL.split('&');
  for (var i = 0; i < URLVariables.length; i++){
    var paramName = URLVariables[i].split('=');
    if (paramName[0] == param){
      return paramName[1];
    }
  }
}

function initMTC(){
  $('#AddToCart').on('click', function(e){
    var selected = $('#productSelect').val();
    var unitType = 'Months';
    var planId;
    var subscriptionId;
    var frequency;

    if(selected == 5285775835177 || selected == 36795355725){
	  // annual
      planId = 33869986189;
      subscriptionId = 72982;
      frequency = 12;
    }else if(selected == 5285775867945 || selected == 36735371085){
	  // monthly
      planId = 34155893005;
      subscriptionId = 66258;
      frequency = 1;
    }else if(selected == 5285775900713 || selected == 36795355661){
      // seasonal
      planId = 34155703629;
      subscriptionId = 72981;
      frequency = 12; //same as annual?
    }

    var response = $.ajax({
      type: 'POST',
      dataType: 'JSON',
      data: {
        'quantity': 1,
        'id': planId,
        'properties[subscription_id]': subscriptionId,
        'properties[shipping_interval_frequency]': frequency,
        'properties[shipping_interval_unit_type]': unitType
      },
      async: false,
      url: '/cart/add.js'
    });

    response.done(function(data){
      console.log('completed');
    });

    response.error(function(error){
      console.log(error)
    });

  });
}

// customer accounts
function preFillEmail(email){
  $('#CustomerEmail').val(email);
}

function getTemplate(){
  return $('body').attr('data-template');
}

function getProductHandle(){
  return $('#se-product-handle').val();
}
